

class SidenavContent {

    sidenav = document.querySelector('.scroll-nav-wrapper .pl-menu-switch') as HTMLElement;

    constructor() {
        this.init();
        window.addEventListener('resize', () => {
            this.init();
        });
    }

    init() {
        if (!this.sidenav) return;

        // now let's get the right column that holds the content

        const sidenavContent = document.querySelector('.sidenav-content-container') as HTMLElement;
        if (!sidenavContent) return;


        // set the left margin of the content to make the content start after the position of the
        // sidenav
        const sidenavWidth = this.sidenav.offsetWidth;
        const sidenavRight = this.sidenav.getBoundingClientRect().right;
        
        // set the left margin of the content to the right position of the sidenav

        const sideNavSections = sidenavContent.querySelectorAll('.pl-section') as NodeListOf<HTMLElement>;
        if (!sideNavSections.length) return;


        const pseudoRightColumn = document.querySelector('.scroll-nav-wrapper .col-lg-9') as HTMLElement;

        sideNavSections.forEach((section) => {
            section.style.paddingLeft = `${sidenavRight }px`;

            const plComponents = section.querySelectorAll('.pl-component') as NodeListOf<HTMLElement>;
            if (!plComponents.length) return;

            const isLastSection = section === sideNavSections[sideNavSections.length -1];

            plComponents.forEach((component) => {
                const pseudoRightColumnWidth = pseudoRightColumn.offsetWidth;
                const lastComponent = plComponents[plComponents.length -1];
                const isFullWidthComponent =
                    (component.classList.contains('key-messaging') && !component.classList.contains('key-messaging--two-column') && !component.classList.contains('key-messaging--three-column')) ||
                    component.classList.contains('cta-full-width-wrapper') ||
                    component.classList.contains('full-width-grid');  

                if (window.innerWidth >= 1200) {
                    component.classList.add('on-sidenav-page');
                    if (!isFullWidthComponent) {
                        const parentSection = component.closest('.pl-section') as HTMLElement;
                        component.style.paddingRight = `${ parentSection.getBoundingClientRect().width - pseudoRightColumn.getBoundingClientRect().right}px`;
                    } else {
                        // round the top left and bottom left corners of the immediate child
                        const childComponent = component.firstElementChild as HTMLElement;
    
                        // check if next sibling is also a full width component
                        const nextSibling = component.nextElementSibling as HTMLElement;
                        const isNextSiblingFullWidth =
                            nextSibling &&
                            ((nextSibling.classList.contains('key-messaging') && !nextSibling.classList.contains('key-messaging--two-column')) ||
                            nextSibling.classList.contains('cta-full-width-wrapper') ||
                            nextSibling.classList.contains('full-width-grid'));
                        const isPrevSiblingFullWidth =
                            component.previousElementSibling &&
                            ((component.previousElementSibling.classList.contains('key-messaging') && !component.previousElementSibling.classList.contains('key-messaging--two-column')) ||
                            component.previousElementSibling.classList.contains('cta-full-width-wrapper') ||
                            component.previousElementSibling.classList.contains('full-width-grid'));
    
                        component.style.overflow = 'hidden';
                        childComponent.style.overflow = 'hidden';
    
                        if (isNextSiblingFullWidth) {
                            component.style.borderBottomLeftRadius = '0px';
                            component.style.borderTopLeftRadius = '8px';
    
                            childComponent.style.borderBottomLeftRadius = '0px';
                            childComponent.style.borderTopLeftRadius = '8px';
                        } else {
                            component.style.borderBottomLeftRadius = '8px';
                            component.style.borderTopLeftRadius = '8px';
    
                            childComponent.style.borderBottomLeftRadius = '8px';
                            childComponent.style.borderTopLeftRadius = '8px';
                        }
    
                        if (isPrevSiblingFullWidth) {
                            component.style.borderTopLeftRadius = '0px';
                            childComponent.style.borderTopLeftRadius = '0px';
                        }
    
                        if (isLastSection && component === lastComponent) {
                            component.style.borderBottomLeftRadius = '0px';
                            childComponent.style.borderBottomLeftRadius = '0px';
                        }
    
                    }

                } else {
                    component.style.paddingRight = `0px`;
                    component.style.borderRadius = '0px';
                    const childComponent = component.firstElementChild as HTMLElement;
                    childComponent.style.borderRadius = '0px';
                    component.classList.remove('on-sidenav-page');
                }

                switch (true) {
                case component.classList.contains("pl-images") &&
                    component.classList.contains("masonry") &&
                    component.classList.contains("scrolling"):
                    this.handleComponentImages(component);
                    break;
                case component.classList.contains("cards") &&
                    component.classList.contains("news") &&
                    !component.classList.contains("masonry"):
                    this.handleNewsCards(component);
                    break;
                default:
                    // handle default case
                    break;
                }
            });
        });

    }

    handleComponentImages(component: HTMLElement) {
        const swiper = component.querySelector('.swiper') as HTMLElement;
        if (!swiper) return;
        const paddingLeft = swiper.style.paddingLeft;

        const parentContainer = swiper.closest('.container') as HTMLElement;
        if (parentContainer) {
            const paddingRight = window.innerWidth - parentContainer.getBoundingClientRect().right;
            swiper.style.paddingRight = `${paddingRight}px`;
            swiper.style.paddingLeft = `${paddingRight}px`;
        }
    }

    handleNewsCards(component: HTMLElement) {
        const rowCards = component.querySelector('.row-cards') as HTMLElement;
        if (!rowCards) return;

        const overlay = component.querySelector('.overlay') as HTMLElement;
        if (!overlay) return;

        // get the height of the row Cards
        const rowCardsHeight = rowCards.offsetHeight;
        
        // set the height of the overlay to the height of the row cards

        // if viewport is between 1400 and 1920, add 48px
        if (window.innerWidth >= 1400 && window.innerWidth < 1920) {
            overlay.style.height = `${rowCardsHeight - 80}px`;
        } else {
            overlay.style.height = `${rowCardsHeight}px`;
        }
    }
}

const plSidenavContent = new SidenavContent();